import type { ReactNode } from 'react';
import type { Language } from '../contexts/TranslationContext';
import type { GuestAnswerReceipt } from '../services/publicGuestQuestion';
import { GuestAnswerEmailForm } from './GuestAnswerEmailForm';
import { GuestAnswerExcerpt } from './GuestAnswerExcerpt';
import './LandingGuestQuestionComposer.css';
import './LandingGuestQuestionAnswer.css';

/** Only the public first sentence is received; the blurred remainder is decorative. */
export function LandingGuestQuestionAnswer({ receipt, locale }: { receipt: GuestAnswerReceipt; locale: Language }) {
  return <GuestAnswerFrame receipt={receipt}><GuestAnswerEmailForm receipt={receipt} locale={locale} /></GuestAnswerFrame>;
}

export function GuestAnswerFrame({ receipt, children }: { receipt: GuestAnswerReceipt; children: ReactNode }) {
  return (
    <article aria-labelledby="landing-guest-answer-title" className="landing-guest-composer relative min-w-0 rounded-[1.75rem] border-0 px-4 py-6 text-left sm:px-8 sm:py-8" data-guest-answer-locked>
      {receipt.preview && <GuestAnswerExcerpt key={receipt.token} preview={receipt.preview} />}
      {children}
    </article>
  );
}
